export default {
    methods: {
        /**
         * @deprecated
         * @param message
         * @returns {string}
         */
        checkError: function(message) {
            return message !== undefined ? 'is-invalid' : '';
        },
    },
};
